import { TOTAL_STARS } from "./Ratings.constants";
/** Round the floating point value to the nearest b/w (0,0.5,1) */

export const getDiscrete = val => {
  if (val >= 0.75) {
    return 1;
  }

  if (val < 0.25) {
    return 0;
  }

  return 0.5;
};
/** Rounds the rating to a discrete value */

export const getDiscreteRating = averageStars => {
  const integer = Math.trunc(averageStars);
  const decimal = averageStars % 1;
  return integer + getDiscrete(decimal);
};
export const getStarCounts = averageStars => {
  const discreteRating = getDiscreteRating(averageStars);
  const yellowStarsCount = Math.trunc(discreteRating);
  const halfStarsCount = Math.ceil(discreteRating % 1);
  const greyStarsCount = TOTAL_STARS - yellowStarsCount - halfStarsCount;
  return {
    yellowStarsCount,
    halfStarsCount,
    greyStarsCount
  };
};